export const GET_CUSTOMER_DETAILS = "getCustomerDetails";
export const SET_CUSTOMER_DETAILS = "setCustomerDetails";
export const GET_MISSIONS_LIST = "getMissionsList";
export const SET_MISSIONS_LIST = "setMissionsList";
export const GET_TOPUPPLAN_LIST = "getTopupPlanList";
export const SET_TOPUPPLAN_LIST = "setTopupPlanList";
export const GET_REWARDSETTING_LIST = "getRewardSettingList";
export const SET_REWARDSETTING_LIST = "setRewardSettingList";
export const GET_STATICBLOCKS_LIST = "getStaticblocksList";
export const SET_STATICBLOCKS_LIST = "setStaticblocksList";
export const GET_PRODUCT_LIST = "getProductList";
export const SET_PRODUCT_LIST = "setProductList";
export const GET_PROMOTION_LIST = "getPromotionList";
export const SET_PROMOTION_LIST = "setPromotionList";

export const GET_GLOBAL_SETTINGS = "getGlobalSettings";
export const SET_GLOBAL_SETTINGS = "setGlobalSettings";
